const G_API = 'AIzaSyCPO-1Oho3Ta20XkP50zPiBVE0OZ16apbE';

export default G_API;